(() => {
  if (window.crepsCollectionCirclesInitialized) return;
  window.crepsCollectionCirclesInitialized = true;

  const desktop = window.matchMedia('(min-width: 1024px)');
  const controllers = new Map();
  const selector = '[data-collection-circles]';

  function paintIndicator(element, controller, show = false) {
    if (!controller.bar || controller.bar.hidden) return;
    const progress = Math.max(0, Math.min(1, element.scrollLeft / controller.maxScroll));
    controller.thumb.style.transform = `translateX(${progress * controller.travel}px)`;
    if (!show) return;
    controller.bar.classList.add('is-scrolling');
    clearTimeout(controller.hideTimer);
    controller.hideTimer = setTimeout(() => controller.bar.classList.remove('is-scrolling'), 1000);
  }

  function measureIndicator(element, controller) {
    if (!controller.bar) return;
    const width = element.clientWidth;
    controller.maxScroll = element.scrollWidth - width;
    controller.bar.hidden = !!controller.swiper || width === 0 || controller.maxScroll <= 0;
    if (controller.bar.hidden) {
      clearTimeout(controller.hideTimer);
      controller.bar.classList.remove('is-scrolling');
      return;
    }
    const ratio = width / element.scrollWidth;
    controller.thumb.style.width = `${ratio * 100}%`;
    controller.travel = width * (1 - ratio);
    paintIndicator(element, controller);
  }

  function destroy(element, controller) {
    if (controller.swiper) controller.swiper.destroy(true, true);
    controller.swiper = null;
    element.classList.remove('collection-circles--enhanced');
  }

  function update(element, controller) {
    if (!desktop.matches) {
      destroy(element, controller);
      measureIndicator(element, controller);
      return;
    }
    if (controller.swiper || !window.Swiper) {
      measureIndicator(element, controller);
      return;
    }

    // Mobile scrolling is entirely native; only desktop needs mouse dragging.
    element.scrollLeft = 0;
    controller.swiper = new window.Swiper(element, {
      observer: true,
      slidesPerView: 'auto',
      spaceBetween: 0,
      freeMode: true,
      mousewheel: { invert: false },
      scrollbar: { el: element.querySelector('.swiper-scrollbar'), hide: true }
    });
    element.classList.add('collection-circles--enhanced');
    measureIndicator(element, controller);
  }

  function dispose(element, controller) {
    destroy(element, controller);
    element.removeEventListener('scroll', controller.onScroll);
    clearTimeout(controller.hideTimer);
    if (controller.resizeObserver) controller.resizeObserver.disconnect();
    controllers.delete(element);
  }

  function initialize(root) {
    const elements = [...root.querySelectorAll(selector)];
    if (root.matches && root.matches(selector)) elements.unshift(root);
    elements.forEach(element => {
      let controller = controllers.get(element);
      if (!controller) {
        const bar = element.nextElementSibling;
        controller = { swiper: null, bar: bar && bar.matches('.collection-circles__scrollbar') ? bar : null };
        controller.thumb = controller.bar && controller.bar.firstElementChild;
        // Only read the scroll offset during momentum: sizing is cached separately.
        controller.onScroll = () => paintIndicator(element, controller, true);
        element.addEventListener('scroll', controller.onScroll, { passive: true });
        if (window.ResizeObserver) {
          controller.resizeObserver = new window.ResizeObserver(() => measureIndicator(element, controller));
          controller.resizeObserver.observe(element);
        }
        controllers.set(element, controller);
      }
      update(element, controller);
    });
  }

  desktop.addEventListener('change', () => {
    controllers.forEach((controller, element) => {
      if (element.isConnected) update(element, controller);
      else {
        dispose(element, controller);
      }
    });
  });
  window.addEventListener('resize', () => {
    controllers.forEach((controller, element) => measureIndicator(element, controller));
  });
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('shopify:section:unload', event => {
    controllers.forEach((controller, element) => {
      if (!event.target.contains(element)) return;
      dispose(element, controller);
    });
  });

  // The theme's deferred Swiper bundle is available by DOMContentLoaded.
  document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
  if (document.readyState !== 'loading') initialize(document);
})();
